import { createSlice, createAction, PayloadAction } from "@reduxjs/toolkit";
import { difference, keyBy, map, union } from "lodash";

// Trigger action for saga compatibility (saga watches this)
export const fetchContents = createAction<any>("contents/trigger");

interface ContentsState {
  requested: string[];
  loading: string[];
  loaded: string[];
  data: Record<string, any>;
}

const initialState: ContentsState = {
  requested: [], // array of machine names requested (to avoid dupe requests for missing stuff)
  loading: [], // array of machine_names that are currently loading
  loaded: [], // array of machine_names that have been loaded successfully
  data: {}, // key by machine_name
};

const contentsSlice = createSlice({
  name: "contents",
  initialState,
  reducers: {
    fetchContentsStart(state, action: PayloadAction<{ machine_name: string }>) {
      const machineNameArray = action.payload.machine_name.split(",");
      state.loading = union(state.loading, machineNameArray);
      state.loaded = difference(state.loaded, machineNameArray);
      state.requested = union(state.requested, machineNameArray);
    },
    fetchContentsSuccess(state, action: PayloadAction<{ data: any[] }>) {
      const machineNameArray = map(action.payload.data, "machine_name");
      // FYI: A missing content record will never be removed from
      // the `loading` array below, or get added to `loaded`.
      state.loading = difference(state.loading, machineNameArray);
      state.loaded = union(state.loaded, machineNameArray);
      state.data = {
        ...state.data,
        ...keyBy(action.payload.data, "machine_name"),
      };
    },
    fetchContentsFailure() {
      // Note that "failure" here would NOT occur due to a missing
      // content record. So, we're not really doing anything right now.
      return { ...initialState, loading: [] };
    },
  },
});

export const { fetchContentsStart, fetchContentsSuccess, fetchContentsFailure } =
  contentsSlice.actions;

export default contentsSlice.reducer;
